// !!! на бою переменные globDev и globDevAjax всегда должны быть false !!!
let globDev = false,
    globDevAjax = false;

let isGlobalReceivedResponseChangeBasked = true;
let isGlobalNoBasketTimeout = true;
let isGlobalBasketRefresh = false;

// константы
// ToDo: получать из env-переменных
const AJAX_URL = '/ajax/'
const VK_PRICE_LIST_ID = 160575;
const OK_ACCOUNT_ID = 3244329;
const OK_LIST_ID = 1;
const DADATA_TOKEN = 'ca01079585fc9867a25e215ef68a36671bb6a0a5';
// todo нужно переделать это на вывод из twig-переменной globalStatic.labels или придумать вариант получше
const LABELS = {
    bestseller: {class: '_green', text: 'Бестселлер'},
    latest: {class: '_blue', text: 'Новинка'},
    week: {class: '_violet', text: 'Книга недели'},
    preorder: {class: '_orange', text: 'Предзаказ'}
}
// if(typeof searchType == 'undefined') {
//     var searchType = 'book';
// }
// глобальные функции
let globalFunctions = {
    
    initBasket: function () {
        globalApp.basket = {};
    },

    formatPrice: function (num, separator = ' ') {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1'+separator)
    },
    
    isFunction: function (functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
    },
    
    /**
     * Проверяет, является ли переданный объект узлом DOM.
     *
     * @param {Object} obj - Объект для проверки.
     * @return {boolean} true, если объект является узлом DOM.
     */
    isDomNode: function(obj) {
        return obj instanceof Element;
    },
    
    delay: function (fn, ms) {
        let timer = 0;
        return function(...args) {
            clearTimeout(timer);
            timer = setTimeout(fn.bind(this, ...args), ms || 0);
        }
    },
    
    /**
     * Native scrollTo with callback
     * @param offset - offset to scroll to
     * @param callback - callback function
     *
     * https://stackoverflow.com/questions/52292603/is-there-a-callback-for-window-scrollto
     */
    
    scrollTo: function (offset, callback) {
        const fixedOffset = offset.toFixed (),
            onScroll = function () {
                if (window.pageYOffset.toFixed () === fixedOffset) {
                    window.removeEventListener ('scroll', onScroll);
                    callback ()
                }
            };
        
        window.addEventListener ('scroll', onScroll);
        onScroll ();
        window.scrollTo ({
            top: offset,
            behavior: 'smooth'
        });
    },
    
    escapeStr: function (str) {
        return String(str).replace(/[&<>"']/g, function (s) {
            return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'}[s];
        });
    },

    declension: function (number, forms, isNumber = false) {
        const cases = [2, 0, 1, 1, 1, 2];
        const formIndex = ((number % 100 > 4) && (number % 100 < 20)) ? 2 : cases[Math.min (number % 10, 5)];
        
        let returnVal = forms[formIndex];
        if (isNumber) {
            returnVal = number + " " + returnVal;
        }
        
        return returnVal;
    },
    
    /*
    Анимация для height: 0 -> height: auto
    Адаптировано решение отсюда
    https://css-tricks.com/using-css-transitions-auto-dimensions/#comment-1607371
    */
    heightOpenClose: function () {
        if ($ (this).hasClass ('_open')) { // close
            $ (this).each (function () {
                $ (this).height ($ (this).get (0).scrollHeight).height ('').removeClass ('_open');
            });
        }
        else { // open
            $ (this).each (function () {
                $ (this).height ($ (this).get (0).scrollHeight).addClass ('_open'); // get height and open
                $ (this).one ('webkitTransitionEnd oTransitionEnd MSTransitionEnd transitionEnd', function () { // after transition complete
                    $ (this).height (''); // revert to CSS-set height
                });
            });
        }
    },
    
    makeSrcset: function (objImg) {
        let srcset = '';
        if (objImg.x3) {
            srcset += objImg.x3 + ' 3x, ';
        }
        if (objImg.x2) {
            srcset += objImg.x2 + ' 2x, ';
        }
        srcset += objImg.x1;
        return srcset;
    },

    bytesToSize: function (bytes) {
        const kilobyte = 1024
        const megabyte = kilobyte * 1024
        const gigabyte = megabyte * 1024
        const terabyte = gigabyte * 1024
        let formatted = ''
        
        if (bytes < kilobyte) {
            formatted = bytes + ' байт'
        } else if (bytes < megabyte) {
            formatted = (bytes / kilobyte).toFixed(2) + ' Кб'
        } else if (bytes < gigabyte) {
            formatted = (bytes / megabyte).toFixed(2) + ' Мб'
        } else if (bytes < terabyte) {
            formatted = (bytes / gigabyte).toFixed(2) + ' Гб'
        } else {
            formatted = (bytes / terabyte).toFixed(2) + ' Тб'
        }
        
        return formatted
    },
    
    // https://css-tricks.com/scroll-triggered-animation-vanilla-javascript/
    scrollTrigger: (els, options = {}) => {
        els = Array.from(els)
        els.forEach(el => {
            if(!('IntersectionObserver' in window)){
                if(options.cb){
                    options.cb(el)
                } else {
                    entry.target.classList.add('active')
                }
                return
            }
            //this takes a callback function which receives two arguments: the elemts list and the observer instance
            let observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if(entry.isIntersecting){
                        if(options.cb){
                            options.cb(el)
                        } else {
                            entry.target.classList.add('active')
                        }
                        observer.unobserve(entry.target)
                    }
                })
            }, options)
            observer.observe(el)
        })
    },
    
    // форматирование урла для ресайзера на картинку произвольного размера
    getResizedImgUrl: (url, width, height) => {
        const imgSplit = url.split('/')
        imgSplit[2] = width + 'x' + height
        return imgSplit.join('/')
    },
    
    // проверка user-agent на бота
    isUserBot: () => {
        const botPattern = "(googlebot\/|bot|Googlebot-Mobile|Googlebot-Image|Google favicon|Mediapartners-Google|bingbot|slurp|java|wget|curl|Commons-HttpClient|Python-urllib|libwww|httpunit|nutch|phpcrawl|msnbot|jyxobot|FAST-WebCrawler|FAST Enterprise Crawler|biglotron|teoma|convera|seekbot|gigablast|exabot|ngbot|ia_archiver|GingerCrawler|webmon |httrack|webcrawler|grub.org|UsineNouvelleCrawler|antibot|netresearchserver|speedy|fluffy|bibnum.bnf|findlink|msrbot|panscient|yacybot|AISearchBot|IOI|ips-agent|tagoobot|MJ12bot|dotbot|woriobot|yanga|buzzbot|mlbot|yandexbot|purebot|Linguee Bot|Voyager|CyberPatrol|voilabot|baiduspider|citeseerxbot|spbot|twengabot|postrank|turnitinbot|scribdbot|page2rss|sitebot|linkdex|Adidxbot|blekkobot|ezooms|dotbot|Mail.RU_Bot|discobot|heritrix|findthatfile|europarchive.org|NerdByNature.Bot|sistrix crawler|ahrefsbot|Aboundex|domaincrawler|wbsearchbot|summify|ccbot|edisterbot|seznambot|ec2linkfinder|gslfbot|aihitbot|intelium_bot|facebookexternalhit|yeti|RetrevoPageAnalyzer|lb-spider|sogou|lssbot|careerbot|wotbox|wocbot|ichiro|DuckDuckBot|lssrocketcrawler|drupact|webcompanycrawler|acoonbot|openindexspider|gnam gnam spider|web-archive-net.com.bot|backlinkcrawler|coccoc|integromedb|content crawler spider|toplistbot|seokicks-robot|it2media-domain-crawler|ip-web-crawler.com|siteexplorer.info|elisabot|proximic|changedetection|blexbot|arabot|WeSEE:Search|niki-bot|CrystalSemanticsBot|rogerbot|360Spider|psbot|InterfaxScanBot|Lipperhey SEO Service|CC Metadata Scaper|g00g1e.net|GrapeshotCrawler|urlappendbot|brainobot|fr-crawler|binlar|SimpleCrawler|Livelapbot|Twitterbot|cXensebot|smtbot|bnf.fr_bot|A6-Indexer|ADmantX|Facebot|Twitterbot|OrangeBot|memorybot|AdvBot|MegaIndex|SemanticScholarBot|ltx71|nerdybot|xovibot|BUbiNG|Qwantify|archive.org_bot|Applebot|TweetmemeBot|crawler4j|findxbot|SemrushBot|yoozBot|lipperhey|y!j-asr|Domain Re-Animator Bot|AddThis)"
        const re = new RegExp(botPattern, 'i')
        const userAgent = navigator.userAgent
        return re.test(userAgent)
    },
    
    // троттлинг функции
    throttle: (func, delay) => {
        let prev = 0;
        return (...args) => {
            let now = new Date().getTime();
            if(now - prev> delay){
                prev = now;
                return func(...args);
            }
        }
    },
    
    // изменить гет-параметр урла
    updateGetParam: (url, param, value) => {
        const urlObject = new URL(url)
        urlObject.searchParams.set(param, value)
        return urlObject.href
    },
    
    // удалить гет-параметр урла
    deleteGetParam: (url, param) => {
        const urlObject = new URL(url)
        urlObject.searchParams.delete(param)
        return urlObject.href
    },
    
    // сделать первую букву строки прописной
    capitalizeFirstLetter: (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1)
    },
    
    /**
     Загружает скрипт по заданному URL-адресу и возвращает Promise с результатом загрузки.
     @param {string} FILE_URL - URL-адрес файла скрипта.
     @param {boolean} async - Определяет, должен ли загружаться скрипт асинхронно. По умолчанию true.
     @param {string} type - Тип скрипта. По умолчанию "text/javascript".
     @returns {Promise} - Promise с объектом статуса загрузки (status) и сообщением об ошибке (message), если возникла ошибка.
     */
    // https://www.educative.io/answers/how-to-dynamically-load-a-js-file-in-javascript
    loadScript: (FILE_URL, async = true, type = "text/javascript") => {
        return new Promise((resolve, reject) => {
            try {
                const scriptEle = document.createElement("script");
                scriptEle.type = type;
                scriptEle.async = async;
                scriptEle.src =FILE_URL;
            
                scriptEle.addEventListener("load", (event) => {
                    resolve({ status: true });
                });
            
                scriptEle.addEventListener("error", (event) => {
                    reject({
                        status: false,
                        message: `Failed to load the script ${FILE_URL}`
                    });
                });
            
                document.body.appendChild(scriptEle);
            } catch (error) {
                reject(error);
            }
        });
    },
    
    /**
     * Проверяет, поддерживает ли устройство ввод touch
     * @return {boolean} true, если устройство поддерживает touch, false в противном случае
     */
    isTouchDevice: () => {
        return ('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0);
    },
    
    /**
     * Разделяет массив на равные части
     * @param {Array} arr - исходный массив
     * @param {number} parts - количество частей, на которые нужно разделить массив
     * @returns {Array} - массив из parts подмассивов
     */
    splitArray: (arr, parts) => {
        const result = [];
        const chunkSize = Math.ceil(arr.length / parts);
        for (let i = 0; i < parts; i++) {
            const start = i * chunkSize;
            const end = start + chunkSize;
            result.push(arr.slice(start, end));
        }
        return result;
    },
    
    /**
     * Форматирует число секунд в отображение таймера
     * Например, 95 сек => 01:35 или 3615 сек => 01:00:15
     * @param {number} seconds - секунды, натуральное число
     * @returns {string} - строка с форматированным отображением
     */
    formatSecondsToTime: (seconds) => {
        const date = new Date(0);
        date.setSeconds(seconds);
        if (seconds > 3599) {
            return date.toISOString().substr(11, 8);
        } else {
            return date.toISOString().substr(14, 5);
        }
    },
    
    /**
     * Возвращает название дня недели на русском языке на основе его числового представления.
     *
     * @param {number} num - Числовое представление дня недели (от 0 до 6, где 0 - воскресенье, 1 - понедельник и т. д.).
     * @returns {Object} - Объект, содержащий название дня недели в именительном и родительном падежах.
     */
    // ToDo добавить падежи, если нужно
    getDayInRus: (num) => {
        return [
            {
                caseNominative: 'воскресенье',
                caseGenitive: 'воскресенья'
            },
            {
                caseNominative: 'понедельник',
                caseGenitive: 'понедельника'
            },
            {
                caseNominative: 'вторник',
                caseGenitive: 'вторника'
            },
            {
                caseNominative: 'среда',
                caseGenitive: 'среды'
            },
            {
                caseNominative: 'четверг',
                caseGenitive: 'четверга'
            },
            {
                caseNominative: 'пятница',
                caseGenitive: 'пятницы'
            },
            {
                caseNominative: 'суббота',
                caseGenitive: 'субботы'
            },
        ][num];
    },
    
    /**
     * Возвращает название месяца на русском языке на основе его числового представления.
     *
     * @param {number} num - Числовое представление месяца (от 0 до 11).
     * @returns {Object} - Объект, содержащий название месяца в именительном и родительном падежах.
     */
    // ToDo добавить падежи, если нужно
    getMonthInRus: (num) => {
        return [
            {
                caseNominative: 'январь',
                caseGenitive: 'января'
            },
            {
                caseNominative: 'февраль',
                caseGenitive: 'февраля'
            },
            {
                caseNominative: 'март',
                caseGenitive: 'марта'
            },
            {
                caseNominative: 'апрель',
                caseGenitive: 'апреля'
            },
            {
                caseNominative: 'май',
                caseGenitive: 'мая'
            },
            {
                caseNominative: 'июнь',
                caseGenitive: 'июня'
            },
            {
                caseNominative: 'июль',
                caseGenitive: 'июля'
            },
            {
                caseNominative: 'август',
                caseGenitive: 'августа'
            },
            {
                caseNominative: 'сентябрь',
                caseGenitive: 'сентября'
            },
            {
                caseNominative: 'октябрь',
                caseGenitive: 'октября'
            },
            {
                caseNominative: 'ноябрь',
                caseGenitive: 'ноября'
            },
            {
                caseNominative: 'декабрь',
                caseGenitive: 'декабря'
            },
        ][num];
    }
};

let globalApp = {
    
    init: function () {

    },
    
    // обновление get-параметра в урле
    // https://stackoverflow.com/questions/1090948/change-url-parameters/10997390#10997390
    updateURLParameter: function (url, param, paramVal) {
        let TheAnchor = null;
        let newAdditionalURL = "";
        let tempArray = url.split ("?");
        let baseURL = tempArray[0];
        let additionalURL = tempArray[1];
        let temp = "";
        
        if (additionalURL) {
            let tmpAnchor = additionalURL.split ("#");
            let TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];
            if (TheAnchor)
                additionalURL = TheParams;
            
            tempArray = additionalURL.split ("&");
            
            // запись в урл параметров, отличных от переданного
            for (let i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split ('=')[0] !== param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }
        else {
            let tmpAnchor = baseURL.split ("#");
            let TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];
            
            if (TheParams)
                baseURL = TheParams;
        }
        
        if (TheAnchor)
            paramVal += "#" + TheAnchor;
        
        let rows_txt = (paramVal !== '') ? temp + "" + param + "=" + paramVal : '';
        return baseURL + ((newAdditionalURL !== "" || rows_txt !== "") ? "?" + newAdditionalURL + rows_txt : "");
    },
    
    catalogFilter: {
        init: false,
        filterGroups: {},
        filterCurrentGroups: {},
        filterData: {},
        sortVal: '',
        noPages: false,
        ajaxUrl: '',
        $itemsContainer: $('.js-catalog-items'),
        
        setUrl: function (url) {
            let sortVal = globalApp.catalogFilter.sortVal;
            
            if (sortVal !== '') {
                url = globalApp.updateURLParameter(url, 'sort', sortVal);
            }
            
            window.history.replaceState('', '', url);
        },
        sendRequest: function () {
            if (globalApp.catalogFilter.init === true) {
                let sortVal = globalApp.catalogFilter.sortVal,
                    noPages = globalApp.catalogFilter.noPages,
                    ajaxData = JSON.parse(JSON.stringify(globalApp.catalogFilter.filterData));
                
                if (sortVal !== '') {
                    ajaxData.sortVal = globalApp.catalogFilter.sortVal;
                }
                
                if (noPages !== false) {
                    ajaxData.noPages = true;
                }
                
                $.ajax({
                    method: 'POST',
                    url: globalApp.catalogFilter.ajaxUrl,
                    data: ajaxData,
                    dataType: 'html',
                    success: function (data) {
                        globalApp.catalogFilter.outputItems(data);
                    },
                    complete: function () {
                    
                    },
                    error: function (xhr, str) {
                    
                    }
                });
            }
        },
        outputItems: function (html, add = false) {
            let $cont = globalApp.catalogFilter.$itemsContainer;
            let $contItems = $('.js-catalog-items');
            if ($cont.length > 0) {
                if (!add) {
                    if(($cont.hasClass('js-aside-wrap') && !$('.catalog-empty',html).length) || !$cont.hasClass('js-aside-wrap')) {
                        $cont.html(html);
                        if($cont.hasClass('js-aside-wrap')) {
                            $(document).trigger('init-filter')
                        }
                    } else {
                        $contItems.html(html);
                    }
                    $('.js-catalog-items').trigger('init-books')
                } else {

                }
            }
        }
    }
};

// Статистика по кликам с баннеров
function statClick(id) {
    $.ajax({
        method: 'POST',
        url: '/api/stat_banner/',
        data: {id: id},
        dataType: 'json'
    });
}

(function () {
    $(function () {
        $('.js-header-droplist-opener').click(function (e) {
            let $_this = $(this);

            $_this.toggleClass('_opened');
        });

        let headSearch = function ($obj) {
            if ($obj instanceof jQuery) {
                let $_this = $obj,
                    $header = $('.js-header-top'),
                    $input = $_this.find('.js-headsearch__input'),
                    $delBtn = $_this.find('.js-headsearch__del'),
                    
                    focusClass = '_searching';
                
                $delBtn.click(function(e){
                    e.preventDefault();
                    $input.val('');
                    $header.removeClass(focusClass);
                });
                
                $input.focus(function(e){
                    if (! $header.hasClass(focusClass)) {
                        $header.addClass(focusClass);
                    }
                })
            }
        };
        
        headSearch($('.js-headsearch'));
    });
}());

(function () {
	$(function () {
        
	    /*
	    
	    Решение для десктопной фиксации положения боковой панели с фильтром в каталоге, без потери возможности её
	    проскроллить
	    
	    Для корректной работы, при ресайзе и изменениях высоты блока, присваиваем обёртке min-height с высотой боковой
	    панели, иначе при коротком списке товаров фильтр невозможно доскроллить до конца
	    
	    При загрузке страницы ждём, пока инициализируются все ползунки и каты в фильтре, и только затем инициализируем
	    минимальную высоту блока (иначе будет некорректное значение)
	    
	     */
	    
	    // TODO прелоадер блока
        
        let lastScrollTop = $ (window).scrollTop ();
        let wasScrollingDown = true;
        const $sidebar = $ ('.js-aside-bar');
        const $wrap = $ ('.js-aside-wrap');
        const $desktopFilter = $sidebar.find ('.js-filt');
        let initialSidebarTop;
        
        if ($sidebar.length === 0 || $wrap.length === 0 || $desktopFilter.length === 0) return false;
        
        
        // проверка, все ли ползунки и каты заинитились
        function isReadyForInit () {
            const $ranges = $desktopFilter.find('.js-filt-range');
            const $rangesInited = $ranges.filter('._inited');
            const $groups = $desktopFilter.find('.js-filt-group');
            const $groupsInited = $groups.filter('._inited');
            
            return $ranges.length === $rangesInited.length && $groups.length === $groupsInited.length;
        }
        
        function recalcHeight () {
            $wrap.css('min-height', $sidebar.innerHeight() + 'px');
        }
        
        function recalcPosition () {
            let windowHeight = $(window).height(),
                wrapHeight = $wrap.outerHeight(),
                wrapTop = $wrap.offset().top,
                wrapBottom = wrapTop + wrapHeight;
    
            let scrollTop = $(window).scrollTop(),
                scrollBottom = scrollTop + windowHeight;
    
            let sidebarHeight = $sidebar.outerHeight();
    
            let sidebarTop = $sidebar.offset().top,
                sidebarBottom = sidebarTop + sidebarHeight;
    
            let heightDelta = Math.abs(windowHeight - sidebarHeight),
                scrollDelta = lastScrollTop - scrollTop;
    
            let isScrollingDown = (scrollTop > lastScrollTop),
                isWindowLarger = (windowHeight > sidebarHeight);
    
            let stopDragging = (scrollBottom >= wrapBottom);
            
            // Проверка на слишком маленькую высоту
            if ($wrap.outerHeight() <= 1000) {
                // Если высота слишком маленькая, фильтр остаётся на месте
            } else if (stopDragging) {
                $sidebar.removeClass('_fixed').addClass('_stopped').css('top', 'auto');
            } else {
                if ($sidebar.hasClass('_stopped')) {
                    $sidebar.addClass('_fixed').removeClass('_stopped').css('top', -heightDelta);
                } else {
                    if ((isWindowLarger && scrollTop > initialSidebarTop) || (!isWindowLarger && scrollBottom > initialSidebarTop + sidebarHeight)) {
                        $sidebar.addClass('_fixed');
                    } else if (!isScrollingDown && scrollTop <= initialSidebarTop) {
                        $sidebar.removeClass('_fixed');
                    }
            
                    let dragBottomDown = (sidebarBottom <= scrollBottom && isScrollingDown),
                        dragTopUp = (sidebarTop >= scrollTop && !isScrollingDown);
            
                    if (dragBottomDown) {
                        if (isWindowLarger) {
                            $sidebar.css('top', 0);
                        } else {
                            $sidebar.css('top', -heightDelta);
                        }
                    } else if (dragTopUp) {
                        $sidebar.css('top', 0);
                    } else if ($sidebar.hasClass('_fixed')) {
                        let currentTop = parseInt($sidebar.css('top'), 10);
                
                        let minTop = -heightDelta,
                            scrolledTop = currentTop + scrollDelta;
                
                        let isPageAtBottom = (scrollTop + windowHeight >= $(document).height()),
                            newTop = (isPageAtBottom) ? minTop : scrolledTop;
                
                        $sidebar.css('top', newTop);
                    }
                }
            }
    
            lastScrollTop = scrollTop;
            wasScrollingDown = isScrollingDown;
        }
        
        // инит
        
        /*
        Здесь, ввиду значительного влияния на производительность, снижаем частоту триггера ресайза
        https://www.onlywebpro.com/2017/03/25/optimize-scrolling-performance-by-debouncing-scroll-event-calls/
         */
        
        $desktopFilter.find ('.js-filt-group, .js-filt-range').on ('is:inited', () => {
            if (isReadyForInit ()) {
                initialSidebarTop = $sidebar.offset ().top;
                
                recalcHeight ();
                if (window.innerWidth > 1039) {
                    recalcPosition ();
                }
                
                let debounceTimerResize;
                $ (window).on('resize', (e) => {
                    if (debounceTimerResize) {
                        window.clearTimeout (debounceTimerResize);
                    }
                    debounceTimerResize = window.setTimeout (function () {
                        if (window.innerWidth > 1039) {
                            recalcHeight ();
                            recalcPosition ();
                        }
                    }, 100);
                });
                
                $sidebar.on ('click', '.js-filt-group__expand', (e) => {
                    setTimeout (() => {
                        recalcHeight ();
                    }, 600);
                });
                
                $ (window).on ('scroll', () => {
                    if (window.innerWidth > 1039) {
                        recalcPosition ();
                    }
                });
            }
        });
    });
}());


(function () {
    $(function () {
        
        $(document).on("basketItemChange", function(e, id, offerId, q, data) {
            let $btns = $('.js-btn-buy[data-offer-id=' + offerId + ']'),
                $btnsQuantity = $('.js-btn-buy-quantity[data-offer-id=' + offerId + ']');

            if ($btns.length > 0) {
                $btns.each(function(){
                    if (q > 0) {
                        if (!$(this).is('._added')) {
                            $(this).addClass('_added');
                        }
                    } else if (q === 0) {
                        if ($(this).is('._added')) {
                            $(this).removeClass('_added');
                        }
                    }
                });
            }

            if ($btnsQuantity.length > 0) {
                $btnsQuantity.each(function(){
                    $(this).find("input").val(q).trigger("change");
                });
            }
        });
        
        $(document).on("change", ".js-btn-buy-quantity input", function(e){
            let $wrap = $(this).parents(".js-btn-buy-quantity"),
                $qText = $wrap.find(".js-btn-buy-quantity-val");

            $qText.text($(this).val());
        });
	});
}());

(function () {
    $(function () {
        /*
        * Проверка кук киалабса и обновление значений в localStorage, если не совпадает
        * */
        let cookieKeaUserId = $.cookie('kea_user_id')
        let cookieKeaCartId = $.cookie('kea_cart_id')
        let storageKeaUserId = localStorage.getItem('kea_user_id')
        let storageKeaCartId = localStorage.getItem('kea_cart_id')
        if (cookieKeaUserId !== storageKeaUserId) {
            if (cookieKeaUserId === undefined) {
                localStorage.removeItem('kea_user_id')
            } else {
                localStorage.setItem('kea_user_id', cookieKeaUserId)
            }
        }
        if (cookieKeaCartId !== storageKeaCartId) {
            if (cookieKeaUserId === undefined) {
                localStorage.removeItem('kea_cart_id')
            } else {
                localStorage.setItem('kea_cart_id', cookieKeaCartId)
            }
        }
    });
}());

function updateWindowScroll (disable) {
    if (disable) {
        $('html').addClass('_filter-open');
    } else {
        $('html').removeClass('_filter-open');
    }
    
    disableBodyScroll(disable);
}

/**
 * Prevent body scroll and overscroll.
 * Tested on mac, iOS chrome / Safari, Android Chrome.
 *
 * Based on: https://benfrain.com/preventing-body-scroll-for-modals-in-ios/
 *           https://stackoverflow.com/a/41601290
 *
 * Use in combination with:
 * html, body {overflow: hidden;}
 *
 * and: -webkit-overflow-scrolling: touch; for the element that should scroll.
 *
 * disableBodyScroll(true, '.i-can-scroll');
 */
var disableBodyScroll = (function () {
    
    /**
     * Private variables
     */
    var _selector = false,
        _element = false,
        _clientY;
    
    /**
     * Polyfills for Element.matches and Element.closest
     */
    if (!Element.prototype.matches)
        Element.prototype.matches = Element.prototype.msMatchesSelector ||
            Element.prototype.webkitMatchesSelector;
    
    if (!Element.prototype.closest)
        Element.prototype.closest = function (s) {
            var ancestor = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (ancestor.matches(s)) return ancestor;
                ancestor = ancestor.parentElement;
            } while (ancestor !== null);
            return el;
        };
    
    /**
     * Prevent default unless within _selector
     *
     * @param  event object event
     * @return void
     */
    var preventBodyScroll = function (event) {
        if (false === _element || !event.target.closest(_selector)) {
            event.preventDefault();
        }
    };
    
    /**
     * Cache the clientY co-ordinates for
     * comparison
     *
     * @param  event object event
     * @return void
     */
    var captureClientY = function (event) {
        // only respond to a single touch
        if (event.targetTouches.length === 1) {
            _clientY = event.targetTouches[0].clientY;
        }
    };
    
    /**
     * Detect whether the element is at the top
     * or the bottom of their scroll and prevent
     * the user from scrolling beyond
     *
     * @param  event object event
     * @return void
     */
    var preventOverscroll = function (event) {
        // only respond to a single touch
        if (event.targetTouches.length !== 1) {
            return;
        }
        
        var clientY = event.targetTouches[0].clientY - _clientY;
        
        // The element at the top of its scroll,
        // and the user scrolls down
        if (_element.scrollTop === 0 && clientY > 0) {
            event.preventDefault();
        }
        
        // The element at the bottom of its scroll,
        // and the user scrolls up
        // https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
        if ((_element.scrollHeight - _element.scrollTop <= _element.clientHeight) && clientY < 0) {
            event.preventDefault();
        }
        
    };
    
    /**
     * Disable body scroll. Scrolling with the selector is
     * allowed if a selector is porvided.
     *
     * @param  boolean allow
     * @param  string selector Selector to element to change scroll permission
     * @return void
     */
    return function (allow, selector) {
        if (typeof selector !== "undefined") {
            _selector = selector;
            _element = document.querySelector(selector);
        }
        
        if (true === allow) {
            if (false !== _element) {
                _element.addEventListener('touchstart', captureClientY, false);
                _element.addEventListener('touchmove', preventOverscroll, {passive: false});
            }
            document.body.addEventListener("touchmove", preventBodyScroll, {passive: false});
        } else {
            if (false !== _element) {
                _element.removeEventListener('touchstart', captureClientY, false);
                _element.removeEventListener('touchmove', preventOverscroll, {passive: false});
            }
            document.body.removeEventListener("touchmove", preventBodyScroll, {passive: false});
        }
    };
}());


// https://gist.github.com/AlexEmashev/ee8302b5036b01362f63dab35948401f
// Demo http://codepen.io/AlexEmashev/pen/BKgQdx
(function ($) {
    $.fn.swipeDetector = function (options) {
        // States: 0 - no swipe, 1 - swipe started, 2 - swipe released
        var swipeState = 0;
        // Coordinates when swipe started
        var startX = 0;
        var startY = 0;
        // Distance of swipe
        var pixelOffsetX = 0;
        var pixelOffsetY = 0;
        // Target element which should detect swipes.
        var swipeTarget = this;
        var defaultSettings = {
            // Amount of pixels, when swipe don't count.
            swipeThreshold: 70,
            // Flag that indicates that plugin should react only on touch events.
            // Not on mouse events too.
            useOnlyTouch: false
        };
        
        // Initializer
        (function init() {
            options = $.extend(defaultSettings, options);
            // Support touch and mouse as well.
            swipeTarget.on('mousedown touchstart', swipeStart);
            $('html').on('mouseup touchend', swipeEnd);
            $('html').on('mousemove touchmove', swiping);
        })();
        
        function swipeStart(event) {
            if (options.useOnlyTouch && !event.originalEvent.touches)
                return;
            
            if (event.originalEvent.touches)
                event = event.originalEvent.touches[0];
            
            if (swipeState === 0) {
                swipeState = 1;
                startX = event.clientX;
                startY = event.clientY;
            }
        }
        
        function swipeEnd(event) {
            if (swipeState === 2) {
                swipeState = 0;
                
                if (Math.abs(pixelOffsetX) > Math.abs(pixelOffsetY) &&
                    Math.abs(pixelOffsetX) > options.swipeThreshold) { // Horizontal Swipe
                    if (pixelOffsetX < 0) {
                        swipeTarget.trigger($.Event('swipeLeft.sd'));
                    } else {
                        swipeTarget.trigger($.Event('swipeRight.sd'));
                    }
                } else if (Math.abs(pixelOffsetY) > options.swipeThreshold) { // Vertical swipe
                    if (pixelOffsetY < 0) {
                        swipeTarget.trigger($.Event('swipeUp.sd'));
                    } else {
                        swipeTarget.trigger($.Event('swipeDown.sd'));
                    }
                }
            }
        }
        
        function swiping(event) {
            // If swipe don't occuring, do nothing.
            if (swipeState !== 1)
                return;
            
            
            if (event.originalEvent.touches) {
                event = event.originalEvent.touches[0];
            }
            
            var swipeOffsetX = event.clientX - startX;
            var swipeOffsetY = event.clientY - startY;
            
            if ((Math.abs(swipeOffsetX) > options.swipeThreshold) ||
                (Math.abs(swipeOffsetY) > options.swipeThreshold)) {
                swipeState = 2;
                pixelOffsetX = swipeOffsetX;
                pixelOffsetY = swipeOffsetY;
            }
        }
        
        return swipeTarget; // Return element available for chaining.
    }
    
}(jQuery));


// https://medium.com/talk-like/detecting-if-an-element-is-in-the-viewport-jquery-a6a4405a3ea2
(function ($) {
    $.fn.isInViewport = function () {
        var elementTop = $ (this).offset ().top;
        var elementBottom = elementTop + $ (this).outerHeight ();
        var viewportTop = $ (window).scrollTop ();
        var viewportBottom = viewportTop + $ (window).height ();
        return elementBottom > viewportTop && elementTop < viewportBottom;
    };
} (jQuery));


(function () {
    /**
     * Добавляет на страницу обёртку для нижних баров
     * и позволяет вставлять туда и удалять оттуда контент
     */
    $(function () {
        let inited = false
        function init() {
            if ($('.js-site-bottom-wrapper').length === 0) {
                inited = true
                $('<div class="site-bottom-wrapper js-site-bottom-wrapper"></div>').appendTo($('body'))
            }
        }

        /**
         * Добавляет в начало списка
         */
        $.fn.prependToBottomWrapper = function () {
            if (!inited)
                init()
            const $_this = $(this).detach()
            return $_this.prependTo('.js-site-bottom-wrapper')
        }
        /**
         * Добавляет в конец списка
         */
        $.fn.appendToBottomWrapper = function () {
            if (!inited)
                init()
            const $_this = $(this).detach()
            return $_this.appendTo('.js-site-bottom-wrapper')
        }
        /**
         * Вырезает элемент и возвращает его
         */
        $.fn.detachFromBottomWrapper = function () {
            const $_this = $(this)
            if ($_this.closest('.js-site-bottom-wrapper')) {
                return $_this.detach()
            }
        }
    });
    
    /**
     * Таймаут ввода в инпуты
     * https://github.com/andrescevp/jquery.donetyping/blob/master/jquery.donetyping.js
     */
    $.fn.extend({
        donetyping: function(callback,timeout){
            timeout = timeout || 1e3; // 1 second default timeout
            var timeoutReference,
                doneTyping = function(el){
                    if (!timeoutReference) return;
                    timeoutReference = null;
                    callback.call(el);
                };
            return this.each(function(i,el){
                var $el = $(el);
    
                ($el.is(':input') || $el.is('textarea')) && $el.on('keyup keypress',function(e){
                    var excludedKeys = [
                        16, 17, 18, 20, 35, 36, 37,
                        38, 39, 40, 45, 144, 225
                    ];
                    // This catches the backspace button in chrome, but also prevents
                    // the event from triggering too premptively. Without this line,
                    // using tab/shift+tab will make the focused element fire the callback.
                    if (e.type=='keyup' &&  $.inArray( e.keyCode, excludedKeys ) !== -1) return;
                
                    // Check if timeout has been set. If it has, "reset" the clock and
                    // start over again.
                    if (timeoutReference) clearTimeout(timeoutReference);
                    timeoutReference = setTimeout(function(){
                        // if we made it here, our timeout has elapsed. Fire the
                        // callback
                        doneTyping(el);
                    }, timeout);
                }).on('blur',function(){
                    // If we can, fire the event since we're leaving the field
                    doneTyping(el);
                });
            });
        }
    });
}());

document.addEventListener("DOMContentLoaded", function() {
    // Проверяем, есть ли в URL хэш
    if(window.location.hash) {
        // Получаем значение хэша
        var hash = window.location.hash.substring(1);  // Обрезаем первый символ '#'
        // Находим элемент по id и прокручиваем к нему
        var element = document.getElementById(hash);
        if (element) {
            setTimeout(function() {
                element.scrollIntoView();
            }, 1000);
        }
    }
});

// Кастомизация настроек виджета чат-бота
document.addEventListener("DOMContentLoaded", function() {
    let isInited = false;
    const initialWidgetSettings = {
        offsetX: 20,
        offsetY: 20,
    };
    
    const recountWidgetSettings = () => {
        const newWidgetSettings = JSON.parse(JSON.stringify(initialWidgetSettings))
        let yValue = initialWidgetSettings.offsetY;
        const hasCookieBar = !!document.body.classList.contains('body_global-hasBottomBar');
        const hasMobileNav = !!document.body.classList.contains('body_has-bottom-nav');
        
        // Устанавливается дефолтное значение для состояния с плашкой про куки и/или моб.навигацией
        if (hasCookieBar) {
            yValue = (window.innerWidth > globObj.breakpoints.sm) ? 100 : 160;
        }
        if (hasMobileNav && window.innerWidth <= globObj.breakpoints.lg) {
            yValue = hasCookieBar ? 220 : 80;
        }
        
        if (document.body.classList.contains('body_page-basket-digital')) {
            // Для страницы электронной корзины
            if (window.innerWidth <= globObj.breakpoints.lg) {
                yValue = (hasCookieBar) ? 320 : 180;
            }
            
        } else if (['body_page-book', 'ab-component__leap', 'body_page-basket'].some(className => document.body.classList.contains(className))) {
            // Для страниц с лип-меню
            if (window.innerWidth <= globObj.breakpoints.lg) {
                yValue = (hasCookieBar) ? 240 : 100;
            }
        }
        
        newWidgetSettings.offsetY = yValue;
        return newWidgetSettings;
    };
    
    const setSettings = (settings) => {
        if (window.fasttrack && window.fasttrack.setSettings) {
            window.fasttrack.setSettings(settings);
        }
    };
    
    // События onReady и onMounted в JS API виджета не срабатывают в такой реализации (возможно, нужно вручную инитить
    // виджет).
    // Поэтому приходится вручную проверять готовность виджета.
    // Сначала проверяем, получен ли объект виджета. Если нет, то делаем 500 попыток раз в 200мс.
    // Если сразу же после этого применить нужные настройки, то виджет иногда может применить свои настройки позднее.
    // Поэтому жёстко применяем настройки вручную раз в 500мс 5 раз. На третью итерацию показываем кнопку.
    // В таком случае минимизируется вероятность того, что виджет будет менять позиционирование при загрузке страницы.
    let initIntervalCnt = 0;
    const initInterval = setInterval(() => {
        if (window.fasttrack) {
            clearInterval(initInterval);
            
            let mountIntervalCnt = 0;
            const mountInterval = setInterval(() => {
                setSettings(recountWidgetSettings());
                
                if (!isInited && mountIntervalCnt > 2) {
                    const widget = document.querySelector('fstrk-widget');
                    if (widget) {
                        widget.setAttribute('data-status', 'initialized');
                        isInited = true;
                    }
                }
                
                if (++mountIntervalCnt > 5) {
                    clearInterval(mountInterval);
                }
            }, 500);
        }
        
        if (++initIntervalCnt > 500) {
            clearInterval(initInterval);
        }
    }, 200);
    
    // Ресайз окна
    window.addEventListener('resize', globalFunctions.throttle(function(event){
        setSettings(recountWidgetSettings());
    }, 100));
    
    // Отлавливается событие скрытия плашки
    document.addEventListener('ab.message.cookies.hide', () => {
        setSettings(recountWidgetSettings());
    });
});
